export enum ListingCategories {
    Sales = 8,
    Rental = 7
}